const liveRoom = {
  path: 'liveRoom/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/liveRoom'], resolve)
}
export default liveRoom
